import React, { useEffect } from 'react';
import { Rate, Tooltip } from 'antd';

interface RatingProps {
  rating?: number;
  numeric?: boolean;
  hoverable?: boolean;
}

const Rating = function ({
  rating = 1,
  numeric = false,
  hoverable = true,
}: RatingProps) {
  const roundedRating = Number(rating).toFixed(1);
  const containerRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.querySelectorAll('li.ant-rate-star')?.forEach((star) => {
        star.setAttribute('tabindex', '-1');
        star.setAttribute('aria-hidden', 'true');
      });
    }
  }, []);

  if (numeric) {
    return <span>{roundedRating}</span>;
  }

  const title = `Rating: ${roundedRating}`;

  const rate = (
    <div ref={containerRef}>
      <Rate
        defaultValue={rating}
        allowHalf
        disabled
        aria-label={title}
      />
    </div>
  );

  return hoverable
    ? <Tooltip title={title}>{rate}</Tooltip>
    : rate;
};

export default Rating;
